// extracted by mini-css-extract-plugin
export default {"navigation":"nJvGv","navigationList":"VvoCV","link":"l5lgD","whiteLink":"sRb2S","isActive":"QsNsy","isActiveWhite":"EEubS"};